import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


@Injectable({ providedIn: 'root' })
export class ToastService {

  constructor(
    private toastrService: ToastrService
  ) {
  }

  info(message: string, title?: string) {
    this.toastrService.info(message, title, { enableHtml: true });
  }

  warning(message: string, title?: string) {
    this.toastrService.warning(message, title, { enableHtml: true });
  }

  success(message: string, title?: string) {
    this.toastrService.success(message, title, { enableHtml: true });
  }

  error(message: string, title?: string) {
    this.toastrService.error(message, title, { enableHtml: true });
  }
}
